import CommonModal from "@components/ui-components/modal";
import DataTableView from "@components/views/datatable-view";
import FormView from "@components/views/form-view";
import InputField from "@components/fields/input-field";
import LoadingButton from "@components/ui-components/loading-button";
import { STATUS_OPTIONS } from "./misc/constants";
import Select from "@components/fields/react-select/select";
import size from "lodash/size";
import usePageChange from "@hooks/use-page-change";
import usePlans from "./use-plans";

const Plans = () => {
    const {
        loading,
        data,
        columns,
        setQueryParams,
        modalConfig,
        toggleModal,
        methods,
        upsertLoading,
        onSubmit
    } = usePlans();

    const { handlePageChange, handlePerRowsChange } = usePageChange({
        setQueryParams
    });

    const isEdit = !!size(modalConfig.row._id);

    const {
        control,
        formState: { errors, isDirty }
    } = methods;

    const content = [
        {
            leftChild: {
                title: "Enter Basic Details",
                desc : "Enter the basic details of the plan which you wish to create"
            },
            rightChild: (
                <>
                    <InputField
                        errors={errors}
                        id="name"
                        label="Name"
                        name="name"
                        required
                        control={control}/>
                    <InputField
                        errors={errors}
                        id="desc"
                        type="textarea"
                        label="Description"
                        name="desc"
                        control={control}/>
                    <Select
                        label="Status"
                        control={control}
                        errors={errors}
                        id="status"
                        required
                        name="status"
                        options={STATUS_OPTIONS}/>
                </>
            )
        }
    ];

    return (
        <>
            <DataTableView
                moduleName={"Plans"}
                breadcrumbItems={{
                    items: [
                        {
                            title : "Plans",
                            active: true
                        }
                    ]
                }}
                actionItems={
                    <LoadingButton
                        color="primary"
                        icon="plus"
                        testId="add-plan"
                        onClick={() => toggleModal()}
                        subject="plans"
                        text="Add Plan"/>
                }
                tableProps={{
                    data      : data.plans,
                    columns,
                    handlePageChange,
                    handlePerRowsChange,
                    pagination: data.pagination
                }}
                loading={loading}/>
            <CommonModal
                title={`${isEdit ? "Edit" : "Add"} Plan`}
                body={<FormView content={content} />}
                confirmButton={{
                    txt    : isEdit ? "Update" : "Add",
                    icon   : "content-save",
                    loading: upsertLoading,
                    onClick: onSubmit
                }}
                type="extraLarge"
                isDirty={isDirty}
                loading={loading}
                handleModal={toggleModal}
                isOpen={modalConfig.open}/>
        </>
    );
};

export default Plans;
